import { router } from '@inertiajs/vue3'
import { useToast } from '@nuxt/ui/composables'
import { onMounted, onUnmounted } from 'vue'

export function useFlash() {
  let removeListener: (() => void) | undefined
  const toast = useToast()

  onMounted(() => {
    removeListener = router.on('flash', (event) => {
      const flash = event.detail.flash
      if (flash.alert) {
        toast.add({
          title: flash.alert,
          color: 'error',
          icon: 'i-lucide-circle-alert',
        })
      }
      if (flash.notice) {
        toast.add({
          title: flash.notice,
          color: 'success',
          icon: 'i-lucide-circle-check',
        })
      }
    })
  })

  onUnmounted(() => {
    if (removeListener) {
      removeListener()
    }
  })
}
